"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attendanceRecordsService = void 0;
var _http = _interopRequireDefault(require("@/config/http"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var attendances = {
  fetchAttendances: function fetchAttendances(params) {
    return _http.default.get("/attendances", {
      params: params
    });
  },
  editAttendance: function editAttendance(data) {
    return _http.default.patch("/attendances/".concat(data.attendanceId), data);
  }
};
var timesheets = {
  fetchTimesheets: function fetchTimesheets(params) {
    return _http.default.get("/attendances/timesheets", {
      params: params
    });
  },
  fetchTimesheetsReports: function fetchTimesheetsReports(params) {
    return _http.default.get("/attendances/timesheets/reports", {
      params: params
    });
  },
  approveExtraHours: function approveExtraHours(data) {
    return _http.default.post("/attendances/timesheets/approve-extra-hours", data);
  }
};
var shiftHours = {
  fetchShiftHours: function fetchShiftHours(params) {
    return _http.default.get("/attendances/shift-hours", {
      params: params
    });
  },
  fetchShiftAssignments: function fetchShiftAssignments(params) {
    return _http.default.get("/attendances/shift-hours/assignments", {
      params: params
    });
  },
  createShiftHours: function createShiftHours(data) {
    return _http.default.post("/attendances/shift-hours", data);
  },
  createShiftAssignment: function createShiftAssignment(data) {
    return _http.default.post("/attendances/shift-hours/assignments", data);
  }
};
var verifiedPhotos = {
  fetchVerifiedPhotos: function fetchVerifiedPhotos(params) {
    return _http.default.get("/attendances/verified-photos", {
      params: params
    });
  },
  createVerifiedPhoto: function createVerifiedPhoto(data) {
    return _http.default.post("/attendances/verified-photos", data);
  },
  deleteVerifiedPhoto: function deleteVerifiedPhoto(id) {
    return _http.default.delete("/attendances/verified-photos/".concat(id));
  }
};
var absences = {
  fetchAbsences: function fetchAbsences(params) {
    return _http.default.get("/attendances/absence-justifications", {
      params: params
    });
  },
  createAbsence: function createAbsence(data) {
    return _http.default.post("/attendances/absence-justifications", data);
  }
};
var devices = {
  fetchDevices: function fetchDevices(params) {
    return _http.default.get("/register-devices", {
      params: params
    });
  },
  updateDevice: function updateDevice(data) {
    return _http.default.patch("/register-devices", data);
  }
};
var attendanceRecordsService = exports.attendanceRecordsService = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, attendances), timesheets), shiftHours), verifiedPhotos), absences), devices);